module.exports = __webpack_public_path__ + "public/img/loading.68a4049d.gif";